<template>
  <transition appear name="fade">
    <div class="modal is-active">
      <div class="modal-background" @click="CloseModal"></div>
      <ValidationObserver v-slot="{ handleSubmit }">
        <div class="modal-content">
          <div class="close" @click="CloseModal">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-box">
            <div class="modal-box-header">
              <h3 v-if="userId">Update</h3>
              <h3 v-if="!userId">Add User</h3>
            </div>
            <div class="field">
              <label class="label"
                ><label class="error_text">*</label>Full Name</label
              >
              <div class="control">
                <ValidationProvider
                  name="Full Name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input v-model="form.name" type="text" class="input" />
                  <span style="color:red; font-size:12px;">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="field">
              <label class="label"
                ><label class="error_text">*</label>Login Email</label
              >
              <div class="control">
                <ValidationProvider
                  rules="email"
                  style="width: 100%;"
                  v-slot="{ errors }"
                >
                  <input v-model="form.email" type="text" class="input" />
                  <span style="font-size: 12px; color: red" id="error">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div v-if="!userId" class="field">
              <label class="label"
                ><label class="error_text">*</label>Password</label
              >
              <div class="control">
                <ValidationProvider
                  name="Password"
                  rules="required|min:8|max:30"
                  v-slot="{ errors }"
                >
                  <input v-model="form.password" type="text" class="input" />
                  <span style="color:red; font-size:12px;">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="field">
              <label for class="label"
                ><label class="error_text">*</label>Role</label
              >
              <div class="control">
                <ValidationProvider
                  name="Role"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <select v-model="form.role" class="input is-focused">
                    <option> Owner </option>
                    <option> Manager </option>
                  </select>
                  <span style="color:red;font-size: 12px">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="close" @click="CloseModal">
              <i class="fal fa-times"></i>
            </div>
            <div class="error_text">{{ errorMessage }}</div>
            <div class="button-group">
              <button
                v-if="userId"
                @click="handleSubmit(updateStaff)"
                class="button primary"
              >
                Update
              </button>
              <button
                v-else
                @click="handleSubmit(addStaff)"
                class="button primary"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </transition>
</template>

<script>
import { ADD_STAFF, UPDATE_STAFF, GET_STAF } from "@/graphql/employer/employer";
import { apolloClient } from "@/services/apollo-client";
export default {
  data: () => ({
    staff: [],
    userId: "",
    errorMessage: "",
    form: {
      UserId: "",
      name: "",
      email: "",
      password: "",
      //:'',
      role: "",
    },
  }),
  created() {},
  watch: {
    userId: {
      handler(val) {
        if (val) {
          this.queryStaff();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    CloseModal() {
      this.$emit("CloseModal");
    },
    async queryStaff() {
      const res = await apolloClient.query({
        query: GET_STAF,
        variables: {
          id: this.userId,
        },
      });
      this.staff = res.data.editUser;
      this.UserId = this.staff.UserId;
      (this.form.name = this.staff.name),
        (this.form.email = this.staff.email),
        //this.form.mobile = this.staff.mobile
        (this.form.role = this.staff.role);
    },
    async addStaff() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      try {
        await apolloClient.mutate({
          mutation: ADD_STAFF,
          variables: {
            userId: this.$route.params.UserId,
            name: this.form.name,
            email: this.form.email,
            password: this.form.password,
            //mobile: parseInt(this.form.mobile),
            role: this.form.role,
          },
        });
      } catch ({ graphQLErrors }) {
        const errorText = graphQLErrors[0].message;
        switch (errorText) {
          case "This email already registed":
            return (this.errorMessage = "ອີເມວນີ້ໄດ້ລົງທະບຽນແລ້ວ");
          case "This mobile already registed":
            return (this.errorMessage = "ເບີໂທນີ້ໄດ້ລົງທະບຽນແລ້ວ");
        }
      }
      this.$router.back();
    },
    async updateStaff() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: UPDATE_STAFF,
        variables: {
          id: this.userId,
          name: this.form.name,
          email: this.form.email,
          // mobile: parseInt(this.form.mobile),
          role: this.form.role,
        },
      });
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.error_text {
  color: red;
}
.modal-content {
  position: relative;
  .close {
    cursor: pointer;
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    right: 0;
    z-index: 999;
    border-radius: 0 0 0 10px;
    background-color: rgba(var(--grey-color), 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 30px;
      color: var(--grey-color);
    }
  }
  .modal-box {
    background-color: #fff;
    padding: 40px;
  }
  .button-group {
    margin-top: 20px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.mobile-format {
  display: flex;
  align-items: center;
  position: relative;
  span {
    position: absolute;
    margin-right: 10px;
    color: var(--primary-color);
    font-weight: 700;
    z-index: 999;
    left: 10px;
  }
  input.input {
    padding-left: 70px;
  }
}
</style>
